import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbf80fc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-young-adults-view" }
const _hoisted_2 = { class: "main-content-title" }
const _hoisted_3 = { class: "order-young-adults-view__copy" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "order-young-adults-view__form margin-top-large" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "margin-top-base" }
const _hoisted_10 = { class: "margin-top-large" }
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "id-inputs" }
const _hoisted_15 = { class: "first-line" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "arrow",
  innerHTML: 'IDD <<'
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "arrow",
  innerHTML: '<<<<<<<<<<<<<<<'
}, null, -1))
const _hoisted_18 = { class: "second-line" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "arrow",
  innerHTML: '<'
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "arrow",
  innerHTML: '<<'
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "arrow",
  innerHTML: '<<<<<<<'
}, null, -1))
const _hoisted_22 = { class: "order-young-adults-view__info margin-top-large" }
const _hoisted_23 = { class: "fw-bold fs-small" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/id-card-example.png",
  width: "226",
  alt: ""
}, null, -1))
const _hoisted_26 = { class: "order-young-adults-view__submit margin-top-large" }
const _hoisted_27 = { class: "order-young-adults-view__info margin-top-large" }
const _hoisted_28 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormElementInputField = _resolveComponent("FormElementInputField")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_ContentArea = _resolveComponent("ContentArea")!

  return (_openBlock(), _createBlock(_component_ContentArea, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("header", null, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.getHeadline()), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              innerHTML: _ctx.getCopy()
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.commonTexts.userFrontend.youngAdultSubscriptionForm
                .bithDateHeadline), 1),
            (_ctx.birthDateErrorHintMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "error-message margin-top-medium error-info fw-bold",
                  innerHTML: _ctx.birthDateErrorHintMessage
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.birthDateHasError)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "error-message margin-top-medium",
                  innerHTML: _ctx.birthDateErrorMessage
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_FormElementInputField, {
                value: _ctx.birthDate,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setBirthDate($event))),
                onBlur: _ctx.formatBirthDate,
                label: 
                _ctx.commonTexts.userFrontend.youngAdultSubscriptionForm
                  .birthDateLabel
              ,
                "field-has-error": _ctx.birthDateHasError
              }, null, 8, ["value", "onBlur", "label", "field-has-error"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.commonTexts.userFrontend.youngAdultSubscriptionForm
                  .idCardHeadline), 1),
              _createElementVNode("p", {
                class: "fs-small",
                innerHTML: 
                _ctx.commonTexts.userFrontend.youngAdultSubscriptionForm.idCardText
              
              }, null, 8, _hoisted_12),
              (_ctx.idCardError)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: _ctx.idCardErrorMessage,
                    class: "error-message margin-top-medium"
                  }, null, 8, _hoisted_13))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_FormElementInputField, {
                    value: _ctx.mrz.line1Field1,
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMrz('line1Field1', $event))),
                    label: 'L01X00T471',
                    "field-has-error": _ctx.idCardError,
                    maxlength: "10",
                    class: "document-number-full"
                  }, null, 8, ["value", "field-has-error"]),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_FormElementInputField, {
                    value: _ctx.mrz.line2Field1,
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setMrz('line2Field1', $event))),
                    label: '8308126',
                    "field-has-error": _ctx.idCardError,
                    maxlength: "7",
                    class: "birth-date-full"
                  }, null, 8, ["value", "field-has-error"]),
                  _hoisted_19,
                  _createVNode(_component_FormElementInputField, {
                    value: _ctx.mrz.line2Field2,
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMrz('line2Field2', $event))),
                    label: '3108011D',
                    "field-has-error": _ctx.idCardError,
                    maxlength: "8",
                    class: "expiry-date-full"
                  }, null, 8, ["value", "field-has-error"]),
                  _hoisted_20,
                  _createVNode(_component_FormElementInputField, {
                    value: _ctx.mrz.line2Field3,
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setMrz('line2Field3', $event))),
                    label: '2108',
                    "field-has-error": _ctx.idCardError,
                    maxlength: "4",
                    class: "serial-number"
                  }, null, 8, ["value", "field-has-error"]),
                  _hoisted_21,
                  _createVNode(_component_FormElementInputField, {
                    value: _ctx.mrz.line2Field4,
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setMrz('line2Field4', $event))),
                    label: '7',
                    "field-has-error": _ctx.idCardError,
                    maxlength: "1",
                    class: "check-digit"
                  }, null, 8, ["value", "field-has-error"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.commonTexts.userFrontend.youngAdultSubscriptionForm
                .idCardInfoHeadline), 1),
            _createElementVNode("p", {
              class: "fs-small",
              innerHTML: 
              _ctx.commonTexts.userFrontend.youngAdultSubscriptionForm.idCardInfoText
            
            }, null, 8, _hoisted_24),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_BasicButton, {
              variant: "primary",
              type: "submit",
              onButtonClicked: _ctx.validateAndProceedToPayment
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.commonTexts.userFrontend.youngAdultSubscriptionForm
                .submitButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["onButtonClicked"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", {
              class: "fs-small",
              innerHTML: _ctx.content.youngAdultSubscriptionForm.textInterest
            }, null, 8, _hoisted_28)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}